export default function ReferAltTwoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
    >
      <g filter="url(#filter0_d_10457_1678)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 20.7995C11 15.0734 15.0681 10.999 20.7843 10.999H43.1464C48.863 10.999 52.9307 15.0739 52.9307 20.7995V43.8986C52.9307 48.9246 48.8626 52.999 43.8453 52.999H20.0854C15.0677 52.999 11 48.9242 11 43.8986V20.7995Z"
          fill="#8065C9"
          stroke="#8065C9"
        />
      </g>
      <path
        d="M36 25C36 23.114 36 22.172 35.414 21.586C34.828 21 33.886 21 32 21C30.114 21 29.172 21 28.586 21.586C28 22.172 28 23.114 28 25M22 33C22 29.229 22 27.343 23.172 26.172C24.343 25 26.229 25 30 25H34C37.771 25 39.657 25 40.828 26.172C42 27.343 42 29.229 42 33C42 36.771 42 38.657 40.828 39.828C39.657 41 37.771 41 34 41H30C26.229 41 24.343 41 23.172 39.828C22 38.657 22 36.771 22 33Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M32 36.333C33.105 36.333 34 35.587 34 34.667C34 33.747 33.105 33 32 33C30.895 33 30 32.254 30 31.333C30 30.413 30.895 29.667 32 29.667M32 36.333C30.895 36.333 30 35.587 30 34.667M32 36.333V37M32 29.667V29M32 29.667C33.105 29.667 34 30.413 34 31.333"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <defs>
        <filter
          id="filter0_d_10457_1678"
          x="0.5"
          y="0.499023"
          width="62.9316"
          height="63"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10457_1678"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10457_1678"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
